import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-bookkeeping-email-filter',
  templateUrl: './bookkeeping-email-filter.component.html',
  styleUrls: ['./bookkeeping-email-filter.component.scss']
})
export class BookkeepingEmailFilterComponent {
  public emailFilterOperators = [
    { text: 'equals', value: '$eq' },
    { text: 'not equal to', value: '$ne' },
    { text: 'starts with', value: '$startsWith' },
    { text: 'ends with', value: '$endsWith' },
    { text: 'contains', value: '$contains' },
    { text: 'does not contain', value: '$notContains' },
    { text: 'is blank', value: '$null' },
    { text: 'is not blank', value: '$notNull' }
  ];

  @Input() public operator: string = '$contains';
  @Output() public operatorChange = new EventEmitter<string>();

  @Input() public text: string = '';
  @Output() public textChange = new EventEmitter<string>();

  @Output() public filterChange = new EventEmitter<void>();
  @Output() public enterPressed = new EventEmitter<void>();

  public get isEmailInputDisabled(): boolean {
    return this.operator === '$null' || this.operator === '$notNull';
  }

  public get selectedOperatorText(): string {
    const found = this.emailFilterOperators.find(op => op.value === this.operator);
    return found ? found.text : '';
  }

  public onOperatorChange(newVal: string): void {
    this.operator = newVal;
    this.operatorChange.emit(newVal);
    this.filterChange.emit();
  }

  public onTextChange(newVal: string): void {
    this.text = newVal;
    this.textChange.emit(newVal);
    this.filterChange.emit();
  }
}
